<template>
    <base-layout
        :header-type="headerType.ALL"
        :footer-type="footerType.PRIMARY"
        :unsaved-puri-count="unsavedPuriCount"
        :latest-image-id="latestImageId"
    >
        <main v-if="servicePolicy">
            <heading-section title="ピクトリンク利用規約" />

            <section class="l-section">
                <div class="l-element">
                    <p class="m-text-comments is-light">
                        このピクトリンク利用規約（以下「本規約」といいます）は、フリュー株式会社（以下「当社」といいます）が運営・提供するサービス『ピクトリンク』の全てのユーザーに対し、その利用条件を定めるものです。ユーザーは、必ず本規約、<link-text :link="privacyPolicyUrl" text="プライバシーポリシー" data-jest="service-policy-1"/>に同意した上で『ピクトリンク』をご利用ください。
                    </p>
                    <p class="m-text-comments is-light">
                        さらに、当社の指定する『ピクトリンク』の会員登録手続を行い、当社による承認を受けた方に限り、『ピクトリンク』に関連する本サービス（第１条に定義）を利用できるものとします。
                    </p>
                    <p class="m-text-comments is-light">
                        なお、ユーザーが未成年者等の制限行為能力者である場合、必ず、法定代理人の方の同意を得てから行ってください。（本規約への同意があった場合、当社はかかる法定代理人の同意を得ているものとみなして『ピクトリンク』に関連する本サービスの提供を開始いたします）
                    </p>
                </div>
            </section>

            <section  class="l-section">
                <heading-plain text="第1章（共通事項）" :isCenter="true"/>
                <div class="l-element">
                    <p class="m-text-comments is-light">
                        本章に定める事項は、『ピクトリンク』の基本的な利用条件その他の契約事項を定めるものであり、『ピクトリンク』内のあらゆるサービスに共通して適用されます。
                    </p>
                </div>

                <section>
                    <heading-bg title="第1条（定義）" />
                    <div class="l-element is-pdb0">
                        <p class="m-text-comments is-light">本規約上で使用する用語の定義は、次の通りとします。</p>
                    </div>

                    <div class="l-element">
                        <ListDefinition :decimal="true">
                            <dt class="m-list-definition-title">本サービス</dt>
                            <dd class="m-list-definition-explanation">『ピクトリンク』（次に定めるプリ画の提供を含み、これに限られない）のウェブサイト及びアプリケーション並びにこれらに関連するサービス全般の総称</dd>
                            <dt class="m-list-definition-title">プリ画</dt>
                            <dd class="m-list-definition-explanation">当社のプリントシール機により撮影して当社所定のサーバーに送信された画像（静止画及び動画を含み、これに限られない）</dd>
                            <dt class="m-list-definition-title">サイト版</dt>
                            <dd class="m-list-definition-explanation">ウェブサイト上で提供される本サービス</dd>
                            <dt class="m-list-definition-title">アプリ版</dt>
                            <dd class="m-list-definition-explanation">モバイル端末向けアプリケーションにより提供される本サービス</dd>
                            <dt class="m-list-definition-title">コンテンツ</dt>
                            <dd class="m-list-definition-explanation">当社が本サービスにて提供する情報・画像（動画を含み、これに限られない）等の総称</dd>
                            <dt class="m-list-definition-title">ユーザー</dt>
                            <dd class="m-list-definition-explanation">本サービスを利用する方全般</dd>
                            <dt class="m-list-definition-title">会員</dt>
                            <dd class="m-list-definition-explanation">当社が定める本サービスの会員登録手続を完了したユーザー</dd>
                            <dt class="m-list-definition-title">会員情報</dt>
                            <dd class="m-list-definition-explanation">会員が本サービスにて登録した情報の総称</dd>
                            <dt class="m-list-definition-title">外部アカウント</dt>
                            <dd class="m-list-definition-explanation">各ユーザーが本サービスの登録時及びログイン時に使用する外部サービスにおける自己のアカウント（Apple ID、X（旧Twitter）アカウント※、LINEアカウント）の総称<br>※ 2024年5月27日以降、X（旧Twitter）アカウントを使用して本サービスに新規登録することはできません。</dd>
                            <dt class="m-list-definition-title">かんたんログイン</dt>
                            <dd class="m-list-definition-explanation">各端末事業者が提供しているユーザー識別ID等を利用した簡易的なログイン方法</dd>
                            <dt class="m-list-definition-title">パスワード</dt>
                            <dd class="m-list-definition-explanation">会員が本サービスを利用するに当たって登録したメールアドレス又は外部アカウントと照合して本人を識別するための文字列</dd>
                            <dt class="m-list-definition-title">個人情報</dt>
                            <dd class="m-list-definition-explanation">氏名、メールアドレス、電話番号、外部アカウント等個人を特定することのできる情報及び、その情報に紐づけられた住所、職業、パスワード、有料サービス利用に伴う課金時の決済番号等の情報の総称</dd>
                            <dt class="m-list-definition-title">端末事業者</dt>
                            <dd class="m-list-definition-explanation">各ユーザーが契約しているインターネット端末（パソコン・モバイル等、その他これらに類似する物を含む）関連サービスを提供する事業者</dd>
                            <dt class="m-list-definition-title">アプリストア事業者</dt>
                            <dd class="m-list-definition-explanation">アプリ版のダウンロード元であるデジタルプラットフォーマー</dd>
                            <dt class="m-list-definition-title">メルマガ</dt>
                            <dd class="m-list-definition-explanation">当社が配信する広告メール（アンケートその他を含む）</dd>
                        </ListDefinition>
                    </div>
                </section>

                <section>
                    <heading-bg title="第2条（その他の規約）" />
                    <div class="l-element">
                        <list-text :decimal="true" :comments="true">
                            <li class="m-list-text-item">本サービスでは、本規約以外の規約・ポリシー等（以下、本サービスの利用条件が規定されている本規約以外の規約・ポリシー等を総称して「その他の規約」といいます）によっても、本サービスの利用条件が規定されています。その他の規約も、名称の如何に関わらず、本規約の一部を構成するものとします。</li>
                            <li class="m-list-text-item">本規約の規定とその他の規約の規定が異なる場合は、当該その他の規約が優先して適用されるものとします。</li>
                            <li class="m-list-text-item">本サービスのアプリ版をダウンロードして利用するユーザーは、利用開始前に、当社の定める各種利用規約の他、アプリストア事業者が定める利用規約等及びプライバシーポリシーの内容を確認するものとします。</li>
                        </list-text>

                    </div>
                </section>

                <section>
                    <heading-bg title="第3条（ID、パスワード及びQRコード管理）" />
                    <div class="l-element">
                        <list-text :decimal="true" :comments="true">
                            <li class="m-list-text-item">会員は、本サービスで使用するID、パスワード及び本サービスのために発行されたQRコードを管理する責任を負うものとします。なお、QRコードは株式会社デンソーウェーブの登録商標です。</li>
                            <li class="m-list-text-item">会員のID、パスワード及びQRコードの管理不十分、第三者による使用等により会員が被る損害については、会員の故意・過失の有無にかかわらず、当社は一切責任を負いません。</li>
                            <li class="m-list-text-item">本サービスの使用にあたって登録したメールアドレス又は外部アカウント並びにパスワードを変更した場合、会員は、速やかに本サービスにて変更の手続を行うものとし、これを怠ったことにより会員に不具合が発生しても、当社は一切の責任を負いません。</li>
                            <li class="m-list-text-item">会員は本サービスの利用にあたり、各端末事業者が提供しているユーザー識別ID等を利用した簡易的なログイン方法（以下「かんたんログイン」といいます）を利用することができます。但し、かんたんログイン方法を利用する場合については、会員と各端末事業者とでご対応頂くこととなるため、かんたんログインに関して、弊社は何等の保証もいたしません。</li>
                        </list-text>
                    </div>
                </section>

                <section>
                    <heading-bg title="第4条（個人情報管理）" />
                    <div class="l-element">
                        <list-text :decimal="true" :comments="true">
                            <li class="m-list-text-item">会員は本サービスを利用する前に当社が定める<link-text :link="privacyPolicyUrl" text="プライバシーポリシー" data-jest="service-policy-2"/>の内容を確認のうえ同意している必要があります。当社は、会員の個人情報を、当社の<link-text :link="privacyPolicyUrl" text="プライバシーポリシー" data-jest="service-policy-3"/>の定めに従い利用することができるものとします。</li>
                            <li class="m-list-text-item">当社は会員に対し、電子メールもしくはSNSメッセージ等の電磁的方法で送信する方法又は本サービスに掲示する方法によって会員向けの連絡・告知・広告（第三者のものを含む）その他の通知及び情報提供を実施できるものとし、会員はこれを予め同意するものとします。かかる通知及び情報提供は、当該送信又は掲示時に直ちに有効となります。</li>
                        </list-text>
                    </div>
                </section>

                <section>
                    <heading-bg title="第5条（会員登録）" />
                    <div class="l-element">
                        <list-text :decimal="true" :comments="true">
                            <li class="m-list-text-item">会員登録を希望するユーザーは、本規約に同意した上で、当社所定の方法で会員登録の申込を行うものとします。なお、入会の申し込みには生年月日の登録が必要となります。</li>
                            <li class="m-list-text-item">会員登録の申込をしたユーザーは、当社がその申込を当社所定の方法により承諾し、登録手続が完了した時点から会員となるものとします。</li>
                            <li class="m-list-text-item">
                                当社は、ユーザーが次の各号のいずれか一つに該当する場合は、当社の判断（当社の完全に自由な裁量による判断とします。以下、本規約において「当社の判断」、「当社単独の判断」、「当社独自の裁量」等とある箇所において同様です）により会員登録の申込を承諾しないことがあります。
                                <list-text :parentheses="true" :comments="true">
                                    <li class="m-list-text-item">当社の定める方法によらず会員登録の申込を行った場合</li>
                                    <li class="m-list-text-item">過去に本規約又は当社の定めるその他の利用規約等に違反したことを理由として会員登録の削除処分を受けた者である場合</li>
                                    <li class="m-list-text-item">不正な手段をもって登録を行っていると当社が判断した場合</li>
                                    <li class="m-list-text-item">会員情報として本人以外（架空名義、匿名等を含むが、これらに限られない）の情報を登録した場合</li>
                                    <li class="m-list-text-item">反社会的勢力又はその構成員や関係者である又はその可能性があると当社が判断した場合</li>
                                    <li class="m-list-text-item">その他当社が不適切と判断した場合</li>
                                </list-text>
                            </li>
                            <li class="m-list-text-item">当社は、ユーザーの会員登録の申込、承諾を証する証書について、ユーザーのために保管することは致しませんので、ユーザーの責任の下でこれらを保管するものとします。</li>
                            <li class="m-list-text-item">(1)ユーザーが本サービスの無料会員として登録する場合、ログイン方法として「かんたんログイン」を任意で選択できます。</li>
                            <li class="m-list-text-item is-marker-hidden">(2)ユーザーが本規約第２章に定める本有料サービスを利用する会員として登録する場合、利用料金の支払方法について当社の指定するネット決済事業者のうち各端末事業者が提供する決済方法を選択したときは、ログイン方法として自動的に「かんたんログイン」が設定されるものとし、当該ユーザーはこの「かんたんログイン」の自動設定に同意しているものとみなします。</li>
                        </list-text>
                    </div>
                </section>

                <section>
                    <heading-bg title="第6条（会員登録の削除）" />
                    <div class="l-element">
                        <list-text :decimal="true" :comments="true">
                            <li class="m-list-text-item">会員が登録の削除を希望する場合、会員は当社所定の方法により会員登録の削除手続を行うものとします。</li>
                            <li class="m-list-text-item">
                                当社は、会員が次の各号のいずれか一つに該当する場合、当社の判断により強制的に会員登録の削除をすることがあります。これにより会員が被る損害については、当社は一切責任を負いません。
                                <list-text :parentheses="true" :comments="true">
                                    <li class="m-list-text-item">当社の定める方法によらずユーザー登録を行ったことが明らかとなった場合</li>
                                    <li class="m-list-text-item">第14条により会員登録の強制削除が妥当と当社が判断した場合</li>
                                    <li class="m-list-text-item">登録されたメールアドレス又は外部アカウントが反社会的勢力又はその構成員や関係者によって取得又は使用されたとき、もしくは使用されるおそれがあると当社が判断したとき</li>
                                    <li class="m-list-text-item">同一の人物において複数のアカウントを所持していると当社が判断した場合</li>
                                    <li class="m-list-text-item">その他当社が不適切と判断した場合</li>
                                </list-text>
                            </li>
                            <li class="m-list-text-item">会員登録の削除時に、会員が当社に対して債務及び義務を負うときは、会員はこの負債及び義務を削除後も引き続き負うものとします。</li>
                        </list-text>
                    </div>
                </section>

                <section>
                    <heading-bg title="第7条（遵守事項）" />
                    <div class="l-element">
                        <list-text :decimal="true" :comments="true">
                            <li class="m-list-text-item">ユーザーは、本サービスを利用して行う自らの行為について一切の責任を負うものとします。</li>
                            <li class="m-list-text-item">会員は、複数の人間が使用する携帯電話上で本サービスを利用する場合、かんたんログイン（ログイン時の登録メールアドレスとパスワードの入力を省略できる機能）又は外部アカウントによるログインの登録解除を行っておかなければなりません。</li>
                        </list-text>
                    </div>
                </section>

                <section>
                    <heading-bg title="第8条（利用環境整備）" />
                    <div class="l-element">
                        <list-text :decimal="true" :comments="true">
                            <li class="m-list-text-item">ユーザーは、本サービスを利用するために必要な機器、ソフトウェア、通信回線等を自らの責任と費用にて整備するものとします。</li>
                            <li class="m-list-text-item">ユーザーはコンピュータウィルスの感染防止等のセキュリティ対策を自己の責任と費用にて講じるものとします。</li>
                            <li class="m-list-text-item">当社はユーザーの利用環境について一切関与せず、また一切の責任を負いません。</li>
                        </list-text>
                    </div>
                </section>

                <section>
                    <heading-bg title="第9条（プリ画の取得方法）" />
                    <div class="l-element">
                        <p class="m-text-comments is-light">
                            ユーザーが当社のプリントシール機で撮影して当社所定のサーバーに送信された画像を本サービスにより取得する方法として、プリントシールに印字されたID（以下「画像ID」といいます）を入力して取得する方法、プリントシールに印字されたQRコードをユーザー自身の携帯端末で読み取って取得する方法、及びユーザーが当社のプリントシール機で撮影するにあたり当社に対し許可を与えて送信されるメールに記載されたURLから取得する方法があります。なお、QRコードは株式会社デンソーウェーブの登録商標です。
                        </p>
                    </div>
                </section>

                <section>
                    <heading-bg title="第10条（携帯転送サービス）" />
                    <div class="l-element">
                        <list-text :decimal="true" :comments="true">
                            <li class="m-list-text-item">
                                当社のプリントシール機の稼働状況や通信回線事情等の理由により、プリ画のアップロードが遅れる場合または送信されず撮影画像が取得できない場合があります。なお、ユーザーがプリ画を取得できない事例としては以下のような事例があります。
                                <list-text :parentheses="true" :comments="true">
                                    <li class="m-list-text-item">プリントシール機にて画像を「携帯に転送する」を選択しなかった場合</li>
                                    <li class="m-list-text-item">プリントシール機の設置店舗にて通信機能をOFFにしている場合</li>
                                    <li class="m-list-text-item">プリントシール機の設置店舗の電波状況が悪く、通信が不可能な場合</li>
                                    <li class="m-list-text-item">画像IDの入力を誤っている場合</li>
                                    <li class="m-list-text-item">ユーザーが画像IDを紛失または消失し、IDを本サービスにおいて入力できない場合</li>
                                    <li class="m-list-text-item">プリントシール機から画像を携帯に転送するサービスが終了した場合</li>
                                </list-text>
                            </li>
                            <li class="m-list-text-item">ユーザーがプリ画を取得できない場合又はユーザーのプリ画の取得が遅れた場合でも、当社はその責任を一切負いません。</li>
                            <li class="m-list-text-item">ユーザーがプリ画を取得するためには、当該プリ画の撮影日から1週間以内に前条に定める方法で取得するものとし、かかる1週間以内にユーザーがプリ画の取得手続きを完了していない場合には、プリ画を取得できません。</li>
                        </list-text>
                    </div>
                </section>

                <section>
                    <heading-bg title="第11条（画像通知メール、画像ID及び画像の管理）" />
                    <div class="l-element">
                        <p class="m-text-comments is-light">
                            ｢画像通知メール｣及び画像ID、ならびにそれらを利用して取得したプリ画は、当該プリ画を撮影したユーザー本人が責任をもって管理するものとします。プリ画を盗用、不正利用その他の事情により撮影したユーザー以外の第三者が取得した場合であっても、かかる盗用、不正利用その他の事情によりユーザーに生じた損害について、当社は一切の責任を負いません。
                        </p>
                    </div>
                </section>

                <section>
                    <heading-bg title="第12条（メルマガの配信）" />
                    <div class="l-element">
                        <p class="m-text-comments is-light">
                            当社は、当社のプリントシール機で入力されたメールアドレス宛に配信した｢画像通知メール｣の｢利用上の注意｣にユーザーが同意の上、本サービスを利用している場合、メルマガを配信することがあります。メルマガは、本利用規約に従って当社によって配信されるものとし、その種類および内容は、その時点で合理的に提供可能なものとします。
                        </p>
                    </div>
                </section>



                <section>
                    <heading-bg title="第13条（禁止行為）" />
                    <div class="l-element">
                        <list-text :none="true" :comments="true">
                            <li class="m-list-text-item">
                                本サービスの利用に際し、当社はユーザーに対し、次に掲げる行為を禁止するものとします。
                                <list-text :parentheses="true" :comments="true">
                                    <li class="m-list-text-item">当社の著作権、商標権等の知的財産権、財産等の権利を侵害する行為、又は侵害するおそれのある行為</li>
                                    <li class="m-list-text-item">第三者の著作権、商標権等の知的財産権、財産、肖像権、プライバシー権等の権利を侵害する行為、又は侵害するおそれのある行為</li>
                                    <li class="m-list-text-item">当社又は第三者の名誉・信用を毀損又は不当に差別もしくは誹謗中傷する行為</li>
                                    <li class="m-list-text-item">第三者の個人情報を事前の許諾なく開示する行為</li>
                                    <li class="m-list-text-item">当社又は第三者に経済的損害を与える行為</li>
                                    <li class="m-list-text-item">当社又は第三者に対する脅迫的な行為</li>
                                    <li class="m-list-text-item">会員が、登録したメールアドレス又は外部アカウント、ID、パスワード又は本サービスのために発行されたQRコードを収集・蓄積し、第三者に譲渡、質入、貸与等する行為</li>
                                    <li class="m-list-text-item">1人が複数のメールアドレス又は外部アカウントを登録して利用する行為</li>
                                    <li class="m-list-text-item">年齢その他の会員情報を偽って登録する行為</li>
                                    <li class="m-list-text-item">他人の情報を登録する行為</li>
                                    <li class="m-list-text-item">当社のサービス経由で発信されたコンテンツの発信元を隠したり、偽装するためにヘッダー加工をする行為</li>
                                    <li class="m-list-text-item">本サービスの運営及びシステムに支障を与える行為</li>
                                    <li class="m-list-text-item">不健全な出会いや、異性との出会いを希望、又は誘導することが主目的であると当社が判断する一切の行為</li>
                                    <li class="m-list-text-item">無差別にメッセージを送信し、友人の追加を依頼する行為</li>
                                    <li class="m-list-text-item">売春・買春等を助長する行為</li>
                                    <li class="m-list-text-item">他人の名義を騙る行為</li>
                                    <li class="m-list-text-item">違反行為により削除されたユーザーを招待する行為</li>
                                    <li class="m-list-text-item">宗教勧誘行為、選挙運動、及び公職選挙法に抵触する行為</li>
                                    <li class="m-list-text-item">法令に違反する行為</li>
                                    <li class="m-list-text-item">公序良俗に反する行為</li>
                                    <li class="m-list-text-item">第三者を代理して、ユーザー御本人以外の画像を取得する行為</li>
                                    <li class="m-list-text-item">上記の他、当社が不適切と判断する一切の行為</li>
                                </list-text>
                            </li>
                        </list-text>
                    </div>
                </section>

                <section>
                    <heading-bg title="第14条（利用制限・削除等）" />
                    <div class="l-element">
                        <list-text :decimal="true" :comments="true">
                            <li class="m-list-text-item">
                                次の各号のいずれか一つに該当する場合、当社は事前通知なく利用停止、利用制限、会員登録の強制削除、将来にわたる利用禁止の措置等必要な措置をとることができるものとします。その場合、当該措置に関する質問・苦情は一切受け付けないものとします。
                                <list-text :parentheses="true" :comments="true">
                                    <li class="m-list-text-item">前条の禁止行為に該当する場合</li>
                                    <li class="m-list-text-item">ユーザーが本規約又は別途定められた規定に違反したとき</li>
                                    <li class="m-list-text-item">ユーザーの利用により、コンピュータウィルスや大量送信メールの拡散など、当社に被害が及ぶおそれがあると当社が判断した場合</li>
                                    <li class="m-list-text-item">当社がユーザーと電子メール等による連絡が不能となった場合</li>
                                    <li class="m-list-text-item">その他、当社が利用制限をかける必要があると判断した場合</li>
                                </list-text>
                            </li>
                            <li class="m-list-text-item">前項の措置に関し、当社はユーザーその他の第三者に対して一切責任を負わないものとします。</li>
                        </list-text>
                    </div>
                </section>

                <section>
                    <heading-bg title="第15条（本サービスの知的財産権）" />
                    <div class="l-element">
                        <list-text :decimal="true" :comments="true">
                            <li class="m-list-text-item">本サービスに関する著作権等を含む一切の権利は、当社又は著作権等を有する第三者に帰属します。</li>
                            <li class="m-list-text-item">ユーザーは、本サービスの内容を当社に無断で転載・複製・改変・蓄積又は転送等の行為を禁止されるものとします。</li>
                        </list-text>
                    </div>
                </section>

                <section>
                    <heading-bg title="第16条（会員作成コンテンツの取扱い）" />
                    <div class="l-element">
                        <list-text :decimal="true" :comments="true">
                            <li class="m-list-text-item">本サービスを利用して編集された文章、画像等については、当社又はその他の媒体・サービスにおいて、当社が必要と判断する処置を行った上で、当社が利用できるものとします。</li>
                            <li class="m-list-text-item">当社は会員の著作物を使用して出版物を発行もしくは本条第３項及び本条第４項以外の目的で利用する際には、事前に当該会員の同意を得るものとします。</li>
                            <li class="m-list-text-item">本条に基づく当社による著作物の利用について、会員は著作者人格権を行使しないものとします。</li>
                        </list-text>
                    </div>
                </section>

                <section>
                    <heading-bg title="第17条（変更等）" />
                    <div class="l-element">
                        <list-text :decimal="true" :comments="true">
                            <li class="m-list-text-item">当社が必要と判断した場合には、ユーザーに通知することなく、いつでも本サービス（コンテンツを含む）の内容を更新、追加、変更、停止、削除又は終了することができるものとします。但し、次章に定める有料サービス（以下「本有料サービス」といい、以下同じとします）の内容を更新、追加、変更、停止、削除又は終了するには、第32条の定めに従うものとします。</li>
                            <li class="m-list-text-item">当社は、当社単独の判断により本規約を変更できるものとし、当社が任意に定めた効力発生日から変更後の内容の効力が発生するものとします。なお、本サービスの利用にあたっては、常に最新の有効な本規約が適用されます。</li>
                            <li class="m-list-text-item">前項の場合、当社は、効力発生日の2週間以上前の相当な時期までに、会員に対し、電子メール又は本サービスに関するウェブサイト又はアプリケーション等において、認識しやすい方法での掲示その他の適切な方法等を用いて、変更内容及び効力発生日を通知します。但し、当該変更による会員の不利益の程度が軽微であると当社が合理的な理由にもとづいて判断した場合、その期間を短縮することができるものとします。</li>
                            <li class="m-list-text-item">前項本文の規定は、規約の変更内容が会員の一般の利益に適合する場合には適用しないものとします。</li>
                            <li class="m-list-text-item">会員が本条に定める本規約の変更に同意しない場合、当社は、本サービスの利用をただちに停止させ又は本サービスの利用契約を解除することができるものとします。</li>
                        </list-text>
                    </div>
                </section>

                <section>
                    <heading-bg title="第18条（免責）" />
                    <div class="l-element">
                        <list-text :decimal="true" :comments="true">
                            <li class="m-list-text-item">当社は、ユーザー間の通信や活動に関与しません。争いが発生した場合、当該ユーザー間で解決するものとし、当社はその責任を負いません。</li>
                            <li class="m-list-text-item">当社は、本サービス（コンテンツを含む、以下同じ）に中断、中止その他の障害が生じないことを保証しません。</li>
                            <li class="m-list-text-item">当社は、本サービス（コンテンツを含む）の内容変更、中断、終了によって生じたいかなる損害についても、一切責任を負いません。</li>
                            <li class="m-list-text-item">当社は、当社独自の裁量により、本サービス上に保存したコンテンツを削除することができ、当該コンテンツが失われても、その責任を負いません。</li>
                            <li class="m-list-text-item">予期せぬ要因で本サービスの閲覧に関して障害が生じた場合、当社は一切責任を負いません。</li>
                            <li class="m-list-text-item">当社は、本サービスの合法性、道徳性、信頼性、正確性、完全性、有用性等を保証するものではなく、これらについて一切の責任を負いません。</li>
                            <li class="m-list-text-item">当社は、本サービスの各ページからリンクしているホームページ及びその商品に関して、合法性、道徳性、信頼性、正確性、完全性、有用性等を保証するものではなく、これらについて一切の責任を負いません。</li>
                            <li class="m-list-text-item">当社は、本サービス及びメルマガ等を通じて広告主等の提携先がユーザー様に提供する商品・サービス・情報及び取引等について、その内容、品質等に限らず一切保証せず、また責任も負いません。提携先が行うプロモーションやキャンペーンは、ユーザーとの間で行われるもので、当社は一切関知しません。</li>
                            <li class="m-list-text-item">
                                本規約が消費者契約法（平成12年法律第61号）第2条第3項の消費者契約法に該当する場合又はその他の理由により当社が会員に対して損害賠償責任を負いうる場合には、本規約のうち、当社の損害賠償責任を完全に免責する規定は適用しないものとします。
                                この場合において、本サービスの利用に関しユーザーに損害が発生し、当社が損害賠償責任を負う場合でも、当社に故意又は重大な過失がある場合を除き、①当社の賠償責任の範囲は、ユーザーに生じた現実且つ直接の通常損害に限られるものとし、当社の予見の有無に関わらず、特別の事情から生じた損害、逸失利益、間接損害、その他の損害については責任を負わないものとします。
                                また、②当社の賠償責任の金額は、損害の事由が発生した時点から遡って12ヶ月の間に当該ユーザーから現実に受領したサービス対価（サービス対価が無償の場合には、現実に受領したサービス対価を1ヶ月あたり100円とみなして計算するものとします）の総額を上限とします。
                            </li>
                        </list-text>
                    </div>
                </section>

                <section>
                    <heading-bg title="第19条（損害賠償）" />
                    <div class="l-element">
                        <p class="m-text-comments is-light">ユーザーの責に帰すべき事由により、当社に損害を与えた場合、ユーザーは、当社にその損害を賠償しなければいけません。</p>
                    </div>
                </section>

                <section>
                    <heading-bg title="第20条（不可抗力）" />
                    <div class="l-element">
                        <p class="m-text-comments is-light">
                            天災、洪水、津波、稲妻、台風、嵐、地震、疫病その他の伝染病、火災、爆発、ストライキ、労働争議、エネルギー供給又は原材料の不足又は統制、その他の法令又は政府機関の行政指導による規制、その他の法定の又は政府による規制、又は他の類似したもしくは類似しない当社の合理的支配の及ばない状況で、直接又は間接的に生じた本規約上の義務の不履行や履行遅滞につき、当社は、ユーザー又は利用者その他の第三者に一切責任を負いません。
                        </p>
                    </div>
                </section>

                <section>
                    <heading-bg title="第21条（本規約及びその他の利用規約等の有効性）" />
                    <div class="l-element">
                        <list-text :decimal="true" :comments="true">
                            <li class="m-list-text-item">本規約及びその他の利用規約等の規定の一部が法令に基づいて無効とされた場合でも、本規約及びその他の利用規約等のその他の規定は有効とします。</li>
                            <li class="m-list-text-item">本規約及びその他の利用規約等の規定の一部があるユーザーとの関係で無効とされ、又は取り消された場合でも、本規約及びその他の利用規約等はその他のユーザーとの関係では有効とします。</li>
                        </list-text>
                    </div>
                </section>

                <section>
                    <heading-bg title="第22条（Apple ID使用に関する特則）" />
                    <div class="l-element">
                        <p class="m-text-comments is-light">
                            本サービスのご利用に際し、米国法人Apple Inc.が提供するサービス『Apple ID」（同社が商号変更や組織再編等をした場合においてこれら変更後の法人により提供されるサービスを含み、以下「Apple ID」といいます）と連携するユーザー又はApple IDを経由するユーザーには、前条までの規約に加え、以下の特則が適用されます。なお、前条までの規約と本条の特則が矛盾抵触する場合、本条の内容が優先して適用されます。
                        </p>
                        <list-text :parentheses="true" :comments="true">
                            <li class="m-list-text-item">本サービスに関し、Apple IDを経由して会員登録を行い、かつ本サービスのログインにApple IDの連携のみを使用している会員（以下「Apple ID会員」といいます）は、iOS向けのアプリ版のみ利用可能です。</li>
                            <li class="m-list-text-item">Apple ID会員が会員登録時に使用したApple IDを変更した場合、当該会員情報は削除されます。</li>
                            <li class="m-list-text-item">Apple ID会員が本有料サービスの利用者である場合、当該会員が本有料サービスの利用申込時に使用したApple IDを変更すると、当該本有料サービスを継続して利用することはできません。</li>
                            <li class="m-list-text-item">Apple ID会員が本有料サービスの利用者である場合、当該会員が有料サービスの解約を希望するときは、当該有料サービスの申込時に使用したApple IDでログインしたiOS向けのアプリ版において解約手続を行う必要があります。iOS向けのアプリ版が使用できない場合、又は有料サービスの申込時に使用されたApple IDが不明な場合、当社では対応することができません。ユーザー自身により、Apple IDのサービス上で手続きを行う、又はApple Inc.の所定の窓口に問い合わせを行う必要があります。</li>
                        </list-text>
                    </div>
                </section>

                <section>
                    <heading-bg title="第23条（お問い合わせ）" />
                    <div class="l-element">
                        <p class="m-text-comments is-light">
                            本サービスへのお問い合わせ先は以下のとおりです。
                        </p>
                        <div class="l-element is-full-width">
                            <Table>
                                <tr>
                                    <th class="m-table-plain-title"><p class="m-text-comments">サイト版の場合</p></th>
                                </tr>
                                <tr>
                                    <td class="m-table-plain-content"><p class="m-text-comments is-light" data-jest="support-add">{{supportAdd}}</p></td>
                                </tr>
                                <tr>
                                    <th class="m-table-plain-title"><p class="m-text-comments">アプリ版の場合</p></th>
                                </tr>
                                <tr>
                                    <td class="m-table-plain-content"><p class="m-text-comments is-light" data-jest="app-support-add">{{appSupportAdd}}</p></td>
                                </tr>
                                <tr>
                                    <th class="m-table-plain-title"><p class="m-text-comments">受付時間</p></th>
                                </tr>
                                <tr>
                                    <td class="m-table-plain-content"><p class="m-text-comments is-light">午前9:30～午後5:00（土・日・祝日・弊社休業日その他当社が指定する日を除く）</p></td>
                                </tr>
                            </Table>
                        </div>
                        <p class="m-text-comments is-light">
                            ※お問い合わせの内容により、返答にお時間をいただく場合がございます。
                        </p>
                    </div>
                </section>

                <section>
                    <heading-bg title="第24条（準拠法及び管轄裁判所）" />
                    <div class="l-element">
                        <list-text :decimal="true" :comments="true">
                            <li class="m-list-text-item">本規約の準拠法は、日本法とします。</li>
                            <li class="m-list-text-item">ユーザーと当社との間で紛争が生じた場合、訴額に応じ、東京簡易裁判所又は東京地方裁判所を第一審の専属的合意管轄裁判所とします。</li>
                        </list-text>
                    </div>
                </section>
            </section>

            <section class="l-section">
                <heading-plain text="第2章（有料サービス）" :isCenter="true"/>
                <div class="l-element">
                    <p class="m-text-comments is-light">
                        本章は、『ピクトリンク』内の有料サービス（以下「本有料サービス」といいます）について、特に利用条件その他の契約事項を定めるものです。なお、本章に定めがない事項については前章が定めるとおりとします。
                    </p>
                </div>

                <section>
                    <heading-bg title="第25条（定義）" />
                    <div class="l-element is-pdb0">
                        <p class="m-text-comments is-light">
                            本章で使用する有料サービスに関する用語の定義は、次のとおりとします。本章に特に定めのない用語については、本規約第１条の定めに従うものとします。
                        </p>
                    </div>

                    <div class="l-element">
                        <ListDefinition :decimal="true">
                            <dt class="m-list-definition-title">本有料会員</dt>
                            <dd class="m-list-definition-explanation">本有料サービスを利用できる会員</dd>
                            <dt class="m-list-definition-title">サイト版有料サービス</dt>
                            <dd class="m-list-definition-explanation">サイト版における本有料サービス</dd>
                            <dt class="m-list-definition-title">アプリ版有料サービス</dt>
                            <dd class="m-list-definition-explanation">アプリ版における本有料サービス</dd>
                            <dt class="m-list-definition-title">プレミアム会員コース</dt>
                            <dd class="m-list-definition-explanation">当社が2025年7月1日以降に提供する本有料サービスの名称 ※サービス内容は当社が別途定めるものとします。</dd>
                            <dt class="m-list-definition-title">有料会員プラスコース</dt>
                            <dd class="m-list-definition-explanation">当社が2025年6月30日まで提供していた本有料サービスの１つで、プレミアム会員コースと同内容のサービス</dd>
                            <dt class="m-list-definition-title">有料会員コース</dt>
                            <dd class="m-list-definition-explanation">当社が2025年6月30日まで提供していた本有料サービスの１つで、有料会員プラスコースの一部のみ利用可能なサービス</dd>
                            <dt class="m-list-definition-title">利用料</dt>
                            <dd class="m-list-definition-explanation">本有料サービスの利用料金</dd>
                            <dt class="m-list-definition-title">ネット決済事業者</dt>
                            <dd class="m-list-definition-explanation">インターネットによる決済（クレジットカード、電子マネー、銀行口座等による決済も含む）サービスを運営する事業者</dd>
                        </ListDefinition>
                    </div>
                </section>

                <section>
                    <heading-bg title="第26条（有料サービス利用契約の締結）" />
                    <div class="l-element">
                        <list-text :decimal="true" :comments="true">
                            <li class="m-list-text-item">ユーザーは必要に応じ、本有料サービスの利用を申し込む前に、本章を含む本規約の他、当社の個人情報保護方針、プライバシーポリシー、本有料サービスに関する特定商取引法に基づく表示等を熟読し、よく理解した上で申し込むものとします。</li>
                            <li class="m-list-text-item">本有料サービスの申込みについて、当社所定の手続が完了した場合、当社と当該ユーザーとの間に本有料サービスの利用に関する契約が締結され、当該ユーザーは本有料会員として登録されます。</li>
                            <li class="m-list-text-item">ユーザーが既に本有料会員として登録されているか否かについて、ユーザー自身の責任と費用において確認するものとし、重複して本有料会員としての登録が行われた場合でも、当社は次条に定める利用料及びその他本有料サービスに関する返金を一切行いません。</li>
                            <li class="m-list-text-item">本有料会員は、携帯電話サービス又は通信サービスを利用できない場合でも、本規約に基づく利用期間の支払義務を免れることはできません。</li>
                            <li class="m-list-text-item">本有料サービスを利用するためには、利用料の他に別途通信料がかかります。本有料会員は「通信料の目安」にて通信料を確認の上、本有料サービスを利用するものとします。なお、ユーザーの利用環境により本有料サービスのダウンロードに数分を要する場合があります。</li>
                            <li class="m-list-text-item">期間限定で利用料を無料とするキャンペーン（名称は問いません）を通じて本有料会員の登録が行われた場合、無料期間終了日の翌日を含む月より自動的に利用料が発生します。</li>
                        </list-text>
                    </div>
                </section>

                <section>
                    <heading-bg title="第27条（有料サービスの支払方法）" />
                    <div class="l-element">
                        <p class="m-text-comments is-light">
                            ユーザーは、有料サービスにかかる利用料の支払方法を、当社の指定するネット決済事業者の中からユーザー自身の選択により決定するものとします。ネット決済事業者に関する詳細については、当社が別途定める<link-text :link="paymentProviderUrl" text="「ネット決済事業者一覧及び特則」" data-jest="payment-provider"/>をご確認ください。
                        </p>
                    </div>
                </section>

                <section>
                    <heading-bg title="第28条（サイト版有料サービスの利用料金等）" />
                    <div class="l-element">
                        <list-text :decimal="true" :comments="true">
                            <li class="m-list-text-item">
                                サイト版有料サービスの料金は月額550円（税込）となります。
                            </li>
                            <li class="m-list-text-item">理由の如何を問わず、既に支払手続が完了した利用料については、一切、減額及び返金されません。</li>
                            <li class="m-list-text-item">サイト版有料サービスは、利用期間満了の１日前までに「自動更新」の設定を解除しない限り、自動的に同内容で更新されます。ユーザーは、このことを十分に注意するものとします。</li>
                            <li class="m-list-text-item">サイト版有料サービスは、ユーザーによる実際の利用の有無を問わず、利用期間中に発生するものとし、ユーザーはこのことを十分に理解しているものとします。</li>
                            <li class="m-list-text-item">サイト版有料サービスを利用しているユーザーが、本有料サービスの契約を自身で解約する場合、または、次条の定めを除く携帯端末に関する契約変更その他のユーザー側の事情により本有料サービスが解約された場合、当該解約手続きが完了した時点でただちに無料会員となり、以後、プレミアム会員コースは利用できなくなります。</li>
                        </list-text>
                    </div>
                </section>

                <section>
                    <heading-bg title="第29条（アプリ版有料サービスの利用料金及び支払等）" />
                    <div class="l-element">
                        <list-text :decimal="true" :comments="true">
                            <li class="m-list-text-item">
                                アプリ版有料サービスの利用料及び支払方法については、以下の方法があります。ユーザーは料金及び支払方法を自己の選択により決定するものとします。なお、利用料の支払方法及び支払時期は、アプリストア事業者の定める規定によります。<br/>
                                <div class="m-payment-table">
                                    <span class="m-payment-block-prefix">（1）App Store決済</span>
                                    <span>
                                        月額払い : 550円（税込）<br>
                                        年額払い : 5,400円（税込）
                                    </span>
                                    <span class="m-payment-block-prefix">（2）Google Play決済</span>
                                    <span>
                                        月額払い : 550円（税込）<br>
                                        年額払い : 5,400円（税込）
                                    </span>
                                </div>
                            </li>
                            <li class="m-list-text-item">(1)ユーザーがアプリ版有料サービスの月額払いを選択した場合、当該ユーザーは、自身が本有料会員として登録された日を起算日とし、翌月同日の前日までの１ヶ月間、本有料サービスを利用することができます。</li>
                            <li class="m-list-text-item is-marker-hidden">(2)ユーザーがアプリ版有料サービスの年額払いを選択した場合、当該ユーザーは、自身が本有料会員として登録された日を起算日とし、翌年同月同日の前日までの１年間、本有料サービスを利用することができます。</li>
                            <li class="m-list-text-item" value="3">本有料会員が利用期間満了前に本有料サービスの解約手続を行った場合、月額払いか年額払いかを問わず、利用料は、一切、減額及び返金されません。</li>
                            <li class="m-list-text-item">本有料サービスは、利用期間満了の24時間前までに「自動更新」の設定を解除しない限り、自動的に同内容で更新されます。なお、利用期間満了前に当社が利用料の改定を行った場合は、当社がこれに反する明確な定めを別途定めない限り、改定後の利用料の内容にて更新されます。</li>
                            <li class="m-list-text-item">App Store決済を利用している本有料会員について、前項の定めに基づきアプリ版有料サービスが自動更新される場合において、支払方法の問題その他の理由により当該自動更新に係るアプリ版有料サービスの利用料の決済が本来の更新日に完了しないときは、当社は、当該本来の更新日から最長16日間（以下「課金猶予期間」といいます。）、当該本有料会員の会員資格を維持し、当該本有料会員に対し本有料サービスの利用を継続して認めることがあります。ただし、ユーザーが自動更新を解除した場合その他ユーザーの意思により本有料サービスを解約した場合は、この限りではありません。</li>
                            <li class="m-list-text-item">課金猶予期間内にApp Store決済によるアプリ版有料サービスの利用料の決済が完了した場合、本有料サービスは、本来の更新日に更新されたものとして取り扱われ、次回以降の更新日も本来の更新サイクルに従うものとします。なお、課金猶予期間内に当該決済が完了しない場合、当該本有料会員は、課金猶予期間の経過をもって無料会員となり、以後、本有料サービスを利用できなくなります。</li>
                        </list-text>
                    </div>
                </section>

                <section>
                    <heading-bg title="第30条（収納代行等）" />
                    <div class="l-element">
                        <list-text :decimal="true" :comments="true">
                            <li class="m-list-text-item">本有料サービスの利用を希望するユーザーは、アプリストア事業者及びネット決済事業者が別途定める約款に基づき、ネット決済事業者が当社に代って利用料の収納を代行すること（ユーザーがクレジットカードによるお支払いを希望される場合、利用料はユーザーがご利用のクレジットカード会社から請求されます）を承諾するものとします。</li>
                            <li class="m-list-text-item">本有料サービスの利用を希望するユーザーは、本規約並びにアプリストア事業者及びネット決済事業者が定める約款及び利用規約（その他の関連利用規約を含みます）の内容を、必ず確認するものとします。 </li>
                            <li class="m-list-text-item">当社がアプリストア事業者又はネット決済事業者に利用料の収納代行を委託した場合でも、利用料にかかる争いについては、ユーザーと当社との間で解決し、ユーザーはアプリストア事業者及びネット決済事業者に対して何らの請求又は苦情の申立を行わないものとします。</li>
                            <li class="m-list-text-item">本有料会員がアプリストア事業者又はネット決済事業者の定める利用料の支払期限を過ぎても支払を行わない場合、ネット決済事業者が当社にユーザーの氏名、住所、連絡先電話番号、利用時期及び利用金額を通知することを承諾するものとします。</li>
                        </list-text>
                    </div>
                </section>

                <section>
                    <heading-bg title="第31条（有料サ―ビス内容の変更等）" />
                    <div class="l-element">
                        <list-text :decimal="true" :comments="true">
                            <li class="m-list-text-item">当社は、当社単独の判断により本有料サービス（コンテンツを含む）の一部または全部を更新、追加、変更、停止、削除又は終了できるものとし、当社が任意に定めた効力発生日から変更後の内容の効力が発生するものとします。</li>
                            <li class="m-list-text-item">前項の場合、当社は、効力発生日の１ヶ月以上前の相当な時期までに、本有料会員に対し、電子メール又は本サービスに関するウェブサイト又はアプリケーション等において、認識しやすい方法での掲示その他の適切な方法等を用いて、変更内容及び効力発生日を通知します。但し、当該変更による会員の不利益の程度が軽微であると当社が合理的な理由にもとづいて判断した場合、その期間を短縮することができるものとします。</li>
                            <li class="m-list-text-item">前項本文の規定は、本有料サービスの変更内容が本有料会員の一般の利益に適合する場合には適用しないものとします。</li>
                            <li class="m-list-text-item">本有料会員が本条に定める本有料サービスの一部または全部の変更に同意しない場合、当社は本サービスの利用をただちに停止させ又は本サービスの利用契約を解除することができるものとします。</li>
                        </list-text>
                    </div>
                </section>

                <section>
                    <heading-bg title="第32条（解約）" />
                    <div class="l-element">
                        <list-text :decimal="true" :comments="true">
                            <li class="m-list-text-item">本有料会員が本有料サービスの解約を希望する場合には、本有料会員自身の携帯端末を通じて当社所定の解約手続を行うものとします。本有料会員の携帯端末を通じて同手続が行われた場合は全て、当社は本有料会員が行った解約手続として取扱うものとします。</li>
                            <li class="m-list-text-item">サイト版有料サービスの場合、本有料会員は、本有料サービスの解約手続きを完了した時点で無料会員となります。</li>
                            <li class="m-list-text-item">サイト版有料サービスの場合、本有料会員が本有料サービスの解約・再登録を同月内で繰り返した場合、本有料会員登録の度に本有料サービス利用料が発生します。なお、本有料会員の新規登録受付を終了したネット決済事業者による本有料サービスの利用の再登録はできません。</li>
                            <li class="m-list-text-item">アプリ版有料サービスの場合、ユーザーが同一のIDで本有料サービスの解約・再登録を利用期間内で繰り返された場合、解約された本有料サービスの当初の利用期間満了日までは、追加料金なく引き続き本有料会員として扱われます。</li>
                            <li class="m-list-text-item">本有料会員と通信事業者等との間の電気通信サービスのご利用に係る契約等、本有料サービスを利用する上で必要となる契約（以下「前提契約」といいます）が解除、解約等により終了した場合又は前提契約等に係る電話番号が変更された場合、当該本有料会員に対する本有料サービスの提供も、前提契約の終了又は電話番号の変更の日をもって自動的に終了するものとします。</li>
                            <li class="m-list-text-item">解約手続完了の通知の送信についてはネット決済事業者によって異なるため、メール等での通知が送信されない場合があります。</li>
                        </list-text>
                    </div>
                </section>

                <section>
                    <heading-bg title="第33条（本有料サービスの停止）" />
                    <div class="l-element">
                        <list-text :decimal="true" :comments="true">
                            <li class="m-list-text-item">当社は当社の事情による設備の保守、管理上やむを得ぬ事由がある場合、及び当社が利用する電気通信事業者の役務が提供されない場合、ユーザーに承諾を得ることなく本有料サービスの提供を停止することができるものとします。</li>
                            <li class="m-list-text-item">
                                当社は、以下の場合、本有料会員に通知することなく本有料サービスの提供を停止し、本有料会員としての登録を抹消する等の措置をとることができるものとします。
                                <list-text :parentheses="true" :comments="true">
                                    <li class="m-list-text-item">本有料会員が支払い期日を過ぎても利用料の支払をしない場合。ただし、第29条第5項に定める課金猶予期間中である場合を除きます。</li>
                                    <li class="m-list-text-item">本有料会員が本規約に定める遵守事項に違反したと当社が判断した場合</li>
                                    <li class="m-list-text-item">ネット決済事業者又はアプリストア事業者が定める規約等に違反した場合</li>
                                    <li class="m-list-text-item">その他、ユーザーとして不適格であると当社が判断した場合</li>
                                </list-text>
                            </li>
                        </list-text>
                    </div>
                </section>

                <section>
                    <heading-bg title="第34条（権利義務の譲渡禁止）" />
                    <div class="l-element">
                        <p class="m-text-comments is-light">
                            本有料会員は、当社に対するいかなる権利又は義務も、第三者に移転又は譲渡することはできません。
                        </p>
                    </div>
                </section>
            </section>
            <section>
                <heading-bg title="利用規約変更履歴" />
                <div class="l-element">
                    <ListDefinition>
                        <dt class="m-list-definition-title">制定日</dt>
                        <dd class="m-list-definition-text">2011年　7月26日</dd>
                        <dt class="m-list-definition-title">改定日</dt>
                        <dd class="m-list-definition-text">2011年　10月20日</dd>
                        <dd class="m-list-definition-text">2012年　3月19日</dd>
                        <dd class="m-list-definition-text">2012年　6月1日</dd>
                        <dd class="m-list-definition-text">2012年　9月4日</dd>
                        <dd class="m-list-definition-text">2013年　12月26日</dd>
                        <dd class="m-list-definition-text">2014年　3月6日</dd>
                        <dd class="m-list-definition-text">2014年　4月18日</dd>
                        <dd class="m-list-definition-text">2014年　8月18日</dd>
                        <dd class="m-list-definition-text">2015年　1月27日</dd>
                        <dd class="m-list-definition-text">2016年　7月5日</dd>
                        <dd class="m-list-definition-text">2017年　6月8日</dd>
                        <dd class="m-list-definition-text">2020年　1月16日</dd>
                        <dd class="m-list-definition-text">2020年　5月10日</dd>
                        <dd class="m-list-definition-text">2021年　7月8日</dd>
                        <dd class="m-list-definition-text">2022年　3月28日</dd>
                        <dd class="m-list-definition-text">2022年　6月1日</dd>
                        <dd class="m-list-definition-text">2023年　3月31日</dd>
                        <dd class="m-list-definition-text">2023年　7月26日</dd>
                        <dd class="m-list-definition-text">2024年　4月23日</dd>
                        <dd class="m-list-definition-text">2024年　5月27日</dd>
                        <dd class="m-list-definition-text">2025年　1月22日</dd>
                        <dd class="m-list-definition-text">2025年　2月17日</dd>
                        <dd class="m-list-definition-text">2025年　7月1日</dd>
                        <dd class="m-list-definition-text">2025年　9月1日</dd>
                        <dd class="m-list-definition-text">2025年　10月1日</dd>
                        <dd class="m-list-definition-text">2025年　12月1日</dd>
                        <dd class="m-list-definition-text">2026年　4月2日</dd>
                        <dd class="m-list-definition-text">2026年　6月16日</dd>
                    </ListDefinition>
                </div>
            </section>
            <div class="l-element">
                <btn-history-back-notify />
            </div>
        </main>
        <loading-heart v-else-if="isLoading"/>
        <error-reload v-else ga-event-label="PRIVACY_POLICY_AGREEMENT_ERROR" data-jest="error-reload"/>
    </base-layout>
</template>

<script>
    import BaseLayout from "../templates/BaseLayout.vue";
    import * as urlUtil from '../../util/UrlUtil'
    import HeadingSection from '../atoms/HeadingSection.vue'
    import HeadingBg from '../atoms/HeadingBg.vue'
    import HeadingPlain from '../atoms/HeadingPlain.vue'
    import ListText from '../atoms/ListText.vue'
    import ListDefinition from '../atoms/ListDefinition.vue'
    import Table from '../atoms/Table.vue'
    import BtnHistoryBackNotify from "../molecules/BtnHistoryBackNotify.vue";
    import * as privacyPolicyAgreementAction from "../../model/action/PrivacyPolicyAgreementAction.js";
    import LoadingHeart from '../atoms/LoadingHeart.vue'
    import ErrorReload from "../organisms/ErrorReload.vue";
    import {headerType} from "../../view-model/enum/HeaderType";
    import {footerType} from "../../view-model/enum/FooterType";
    import LinkText from "../atoms/LinkText.vue";
    import {mapActions} from "vuex";
    import {helpUrlUtil} from "../../util/UrlUtil";

    export default {
        name: 'Terms',
        components: {
            BaseLayout,
            LinkText,
            BtnHistoryBackNotify,
            HeadingSection,
            HeadingBg,
            HeadingPlain,
            ListText,
            ListDefinition,
            Table,
            LoadingHeart,
            ErrorReload,
        },
        props: {
            /**
             * Headerコンポーネント用
             * vm経由でtoolboxから情報を渡す
             */
            unsavedPuriCount: {
                type: String,
                required: true
            },
            latestImageId: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                paymentProviderUrl: urlUtil.policyUrlUtil.paymentProviderUrl(),
                privacyPolicyUrl: urlUtil.policyUrlUtil.privacyPolicyUrl(),
                supportAdd: urlUtil.mailAddUtil.supportAdd(),
                appSupportAdd: urlUtil.mailAddUtil.appSupportAdd(),
                helpUrlShareAlbum: helpUrlUtil.helpDetailUrl(60),
                isLoading: true,
                servicePolicy: null,
                headerType: headerType,
                footerType: footerType
            }
        },
        mounted() {
            this.getPolicyUrl()
            /**
             * TheHeader,TheFooterでstoreのaccountStatusを使用するため、予めstoreに保存しておく
             * FIXME:ここでの取得を忘れてもエラーが出ず気づかない可能性があるため、VOYAGERFRONT-5558で修正予定
             */
            this.getAccountStatus()
        },
        methods: {
            ...mapActions({
                getAccountStatus: 'AccountStoreV2/getAccountStatus'
            }),
            // FIXME: PICTLINK-13734でservicePolicyを使わないよう変更したのでこの処理はおそらく不要になったが、レビュー無しでのリリースだったので安全を期して何も触りませんでした
            getPolicyUrl() {
                privacyPolicyAgreementAction.getPrivacyPolicyStatuses()
                    .then(result => {
                        this.servicePolicy = result.servicePolicy
                        this.isLoading = false
                    })
                    .catch(_error => {
                        this.isLoading = false
                    });
            },
        }
    }
</script>
